import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { AdministrativeManagementDigitalizationKpiCfg, AdministrativeManagementDigitalizationKpiCfgService } from "./administrativeManagementDigitalizationKpiCfg.service";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class ClientDetail {
    public officeId: string;
    public nif: string;
    public name: string;
    public clientCode: number;
    public centerCode: number;
    public clientFiscalName: string;
    public centerSegment: string;
}

export class ClientsWoBulletinsDetailServiceData {
    public clients: ClientDetail[];
    public updateTimestamp: Date;
}

@Injectable()
export class ClientsWoBulletinsDetailService extends KpiService<ClientsWoBulletinsDetailServiceData> {
    public getClassName() { return "ClientsWoBulletinsDetailService"; }

    constructor(
        private serviceCfg: AdministrativeManagementDigitalizationKpiCfgService,
        private apigeeService: ApigeeService,
        private impersonationService: ImpersonationService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<ClientsWoBulletinsDetailServiceData> {

        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: ClientsWoBulletinsDetailServiceData = null;
            try {
                let cfg: AdministrativeManagementDigitalizationKpiCfg = this.serviceCfg.getCfg();
                let url = cfg.clientsWoBulletins.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                result = await this.httpClient.post<ClientsWoBulletinsDetailServiceData>(url, this.impersonationService.getNifImpersonate()).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
